import { useState, useEffect, useRef, useCallback } from 'react';

const MroCatalogTree = ({ catalogListData }) => {
  const [idx, setIdx] = useState(0);
  const isManualScroll = useRef(false);
  const scrollTimeout = useRef(null);
  const lastUpdateTime = useRef(0);

  // 更新高亮索引的函数，带防抖
  const updateActiveIndex = useCallback(() => {
    if (isManualScroll.current) return;
    if (!catalogListData || catalogListData.length === 0) return;

    const now = Date.now();
    // 防止过于频繁的更新（至少间隔 150ms）
    if (now - lastUpdateTime.current < 150) return;

    const headerHeight = 120;
    let currentIndex = 0;

    // 遍历所有分类元素，找到当前应该高亮的
    for (let i = 0; i < catalogListData.length; i++) {
      const element = document.getElementById(`${catalogListData[i].mroCatalogId}catalog`);
      if (element) {
        const rect = element.getBoundingClientRect();
        // 如果元素顶部在视口上方或刚进入视口
        if (rect.top <= headerHeight + 50) {
          currentIndex = i;
        } else {
          break;
        }
      }
    }

    // 只有当索引真正改变时才更新
    setIdx((prevIdx) => {
      if (prevIdx !== currentIndex) {
        lastUpdateTime.current = now;
        return currentIndex;
      }
      return prevIdx;
    });
  }, [catalogListData]);

  // 滚动事件监听
  useEffect(() => {
    if (!catalogListData || catalogListData.length === 0) return;

    const handleScroll = () => {
      // 清除之前的定时器
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      // 使用防抖，避免频繁更新
      scrollTimeout.current = setTimeout(() => {
        updateActiveIndex();
      }, 150);
    };

    // 初始化时执行一次
    setTimeout(() => {
      updateActiveIndex();
    }, 200);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [catalogListData, updateActiveIndex]);

  const selectFn = (item, index) => {
    // 标记为手动滚动
    isManualScroll.current = true;
    setIdx(index);

    const targetItem = document.getElementById(`${item.mroCatalogId}catalog`);

    if (targetItem) {
      // 获取目标元素相对于页面顶部的位置
      const targetRect = targetItem.getBoundingClientRect();
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 计算目标位置
      const headerHeight = 100;
      const targetScrollPosition = currentScrollTop + targetRect.top - headerHeight;

      // 平滑滚动到目标位置
      window.scrollTo({
        top: targetScrollPosition,
        behavior: 'smooth',
      });

      // 滚动结束后恢复自动高亮（增加延迟时间）
      setTimeout(() => {
        isManualScroll.current = false;
      }, 1500);
    }
  };

  const catalogTreeHtml = catalogListData?.map((item, index) => {
    return (
      <li
        key={item.mroCatalogId}
        className={`pl-[15px] truncate text-[14px] font-medium  leading-[26px] hover:text-[#0096E6] cursor-pointer hover:underline ${idx === index ? 'text-[#0093E6]' : 'text-[#444]'}`}
        onClick={() => selectFn(item, index)}
      >
        {item.catalogName}
      </li>
    );
  });

  return (
    <div className="sticky top-[102px] bg-[#fff] rounded-[3px_3px_0px_0px] w-[202px] h-[760px] border-[1px] border-solid border-[#f0f0f0]">
      <p className="pl-[15px] w-[100%] h-[52px] leading-[52px] bg-[#F0F0F0] text-[16px] font-semibold">类别</p>
      <ul className="w-[100%] h-[700px] mt-[9px] overflow-y-auto">{catalogTreeHtml}</ul>
    </div>
  );
};

export default MroCatalogTree;
